module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7107e149eb1e1f74e4f8fde433558d98.png";